

const loginDomain = 'qpr.co.uk'
const tokenEndpoint = 'https://sa-api.gc.ipswichtownfcservices.co.uk/v1'
const urlParams = new URLSearchParams(window.location.search);
let tokenpayload = urlParams.get('tokenpayload');
let saUser = null // Stores the Sports Alliance User Object for use elsewhere in the application

const ssoUserID = document.cookie.replace(/(?:(?:^|.*;\s*)_sa_sso_upid\s*\=\s*([^;]*).*$)|^.*$/, "$1");
let refreshToken = document.cookie.replace(/(?:(?:^|.*;\s*)_gc_sa_sso_refresh\s*\=\s*([^;]*).*$)|^.*$/, "$1");
let accessToken = document.cookie.replace(/(?:(?:^|.*;\s*)_gc_sa_sso_access\s*\=\s*([^;]*).*$)|^.*$/, "$1");

// Sports Alliance 'shift' values
const upperCase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
const lowerCase = 'abcdefghijklmnopqrstuvwxyz'
const mShift = 11
const shiftLength = 26 - mShift //numbers of letters in the alphabet - length of m
const nEntropy = 22
const mEntropy = 22

function extractTokens(payload) {
        var processedPayload = deobfuscatePayload(payload)

        console.log('processedPayload', processedPayload)

        var search = processedPayload.substring(0);
        const queryObject = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        return queryObject
}

function deobfuscatePayload(payload) {
        // removing the random entropy of length m at index n
        var extractedString = payload.substring(nEntropy, nEntropy + mEntropy)
        var requiredStringParts = payload.split(extractedString)
        var splicedResponse = requiredStringParts[0] + requiredStringParts[1]

        // var test = 'm'
        let newString = '' //The string which will be built up after reversing the Caeser Shift

        let i;
        for (i = 0; i < splicedResponse.length; i++) {
            // console.log('processing', splicedResponse[i])
            newString = newString + getShiftedLetter(splicedResponse[i])
        }

        console.log('Post shift string', newString)

        let token = atob(newString)

        console.log('base64 decoded string', token)

        return token

    }

function getShiftedLetter(letter) {
        if (isNaN(letter)) { // If it is not a number then we convert it, otherwise we just leave it
            var alphabet = ''
            if (letter == letter.toUpperCase()) {
                alphabet = upperCase
            } else {
                alphabet = lowerCase
            }

            var originalPosition = alphabet.indexOf(letter)

            var shiftedPosition = originalPosition + shiftLength
            if (shiftedPosition > (alphabet.length - 1)) {
                var loopBackCount = shiftedPosition - (alphabet.length - 1)
                return alphabet[loopBackCount - 1]
            } else {
                return alphabet[shiftedPosition]
            }
        } else {
            return letter
        }
    }

    function parseJwt(token) {
      try {
        return JSON.parse(atob(token.split('.')[1]));
      } catch (e) {
        return null;
      }
    }

// If a login has occured (because the tokenpayload param exists)
if(tokenpayload){
  
  console.log('LOGIN Performed token detected')
  var tokens = extractTokens(tokenpayload)
  console.log('TOKENS',tokens)
  document.cookie = `_gc_sa_sso_refresh=${tokens.refresh_token}; expires=${tokens.refresh_token_expires_utc}; path=/; domain=.${loginDomain};`;
  document.cookie = `_gc_sa_sso_access=${tokens.access_token}; expires=${tokens.access_token_expires_utc}; path=/; domain=.${loginDomain};`;
  saUser = parseJwt(tokens.access_token)
  console.log('SA User',saUser);
  window.location.href="https://"+Shopify.shop;
  
} else if (!ssoUserID) {
  console.log('No LOGIN Performed or user detected')
  document.cookie = `_gc_sa_sso_refresh=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
  document.cookie = `_gc_sa_sso_access=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
  
} else if (ssoUserID && refreshToken) {
  console.log('No LOGIN but user and refresh token detected')

  if (accessToken) {
    console.log('Access token exists')
    saUser = parseJwt(accessToken)
    console.log('SA User',saUser)
  } else if (refreshToken){
    console.log('No access token exists, using refresh token')

    var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`${tokenEndpoint}/refresh_token?refresh_token=${refreshToken}?user_agent_pass=true`, requestOptions)
      .then(response => response.text())
      .then(result => {
        console.log(result)
        var resultData = JSON.parse(result)
        console.log(resultData) 
        if(resultData.success === true){
          console.log('Refresh token success')
          document.cookie = `_gc_sa_sso_refresh=${resultData.response.refresh_token}; expires=${resultData.response.refresh_token_expires_utc}; path=/; domain=${loginDomain};`;
          document.cookie = `_gc_sa_sso_access=${resultData.response.access_token}; expires=${resultData.response.access_token_expires_utc}; path=/; domain=${loginDomain};`;
        } else {
          console.log('Refresh token fail')
          // Failed response - not logged in
          document.cookie = `_gc_sa_sso_refresh=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
          document.cookie = `_gc_sa_sso_access=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
        }
       
      })
      .catch(error => {
        console.error('Unable to login', error)
        // Clear refresh cookie
        document.cookie = `_gc_sa_sso_refresh=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
        document.cookie = `_gc_sa_sso_access=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
      });
  
  } else {
    console.log('No access token exists or refresh token exists')
  }

} else if(ssoUserID) {
  console.log('Session exists but refresh and access tokens do not exist')
  
  var requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`${tokenEndpoint}/sessionsignin/${deobfuscatePayload(ssoUserID)}?user_agent_pass=true`, requestOptions)
      .then(response => response.text())
      .then(result => {
        console.log(result)
        var resultData = JSON.parse(result)
        console.log(resultData) 
        if(resultData.success === true){
          console.log('Refresh token success')
          document.cookie = `_gc_sa_sso_refresh=${resultData.response.refresh_token}; expires=${resultData.response.refresh_token_expires_utc}; path=/; domain=${loginDomain};`;
          document.cookie = `_gc_sa_sso_access=${resultData.response.access_token}; expires=${resultData.response.access_token_expires_utc}; path=/; domain=${loginDomain};`;
        } else {
          console.log('Refresh token fail')
          // Failed response - not logged in
          document.cookie = `_gc_sa_sso_refresh=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
          document.cookie = `_gc_sa_sso_access=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
        }
       
      })
      .catch(error => {
        console.error('Unable to login', error)
        // Clear refresh cookie
        document.cookie = `_gc_sa_sso_refresh=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
        document.cookie = `_gc_sa_sso_access=; expires = Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${loginDomain};`
      });
} else {
  
  console.log('No LOGIN data present')
  
}